import { Env } from '@sanlam-glacier/app-common/types/env/Env.type.js';
import { appStore, envAtom, setAppStore } from './app.store';

interface StateService {
  getEnv: () => Env;
  setStore: (environmentConfig: Env) => void;
}

export const stateService: StateService = {
  getEnv: (): Env => appStore.get(envAtom)!,
  setStore: (environmentConfig: Env): void => {
    setAppStore(environmentConfig);
  }
};
